import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { Tag } from "@msuite/ui/tag";
import { getAbsenceCategoryTranslationKey } from "@msuite/utils/absences";
import { getColorByString } from "@msuite/utils/colors";
import { moment } from "@msuite/utils/date";
import { formatNumber } from "@msuite/utils/numbers";
import type { AbsenceListItem } from "@msuite/utils/types";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<AbsenceListItem>();

export const columns = [
	columnHelper.accessor("startDate", {
		id: "startDate",
		header: localized("dates.start_date"),
		cell: (cell) =>
			[
				moment(cell.getValue()).dateFormat(),
				cell.row.original.halfDayStart ? `(${localized("absences.half_day")})` : "",
			]
				.join(" ")
				.trim(),
	}),
	columnHelper.accessor("endDate", {
		id: "endDate",
		header: localized("dates.end_date"),
		cell: (cell) =>
			[
				moment(cell.getValue()).dateFormat(),
				cell.row.original.halfDayEnd ? `(${localized("absences.half_day")})` : "",
			]
				.join(" ")
				.trim(),
	}),
	columnHelper.accessor((row) => localized(getAbsenceCategoryTranslationKey(row.category)), {
		id: "category",
		header: localized("absences.category.category"),
		cell: (cell) => (
			<Tag
				color={getColorByString(cell.row.original.category)}
				variant="plain"
			>
				{cell.getValue()}
			</Tag>
		),
	}),
	columnHelper.accessor((row) => row.name, {
		id: "type",
		header: localized("absences.absence_type"),
		cell: (cell) => (
			<Tag
				color={getColorByString(cell.row.original.name)}
				variant="plain"
			>
				{cell.getValue()}
			</Tag>
		),
	}),
	columnHelper.accessor((row) => formatNumber(row.consumedDays, "day"), {
		id: "calculated-days",
		header: localized("absences.vacation_days"),
		cell: (cell) => cell.getValue(),
	}),
	createRowActions(RowActions),
];
